import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = "G-0R8453C4HF";

export default function usePageTracking() {
    const location = useLocation();

    useEffect(() => {
        if (!window.gtag) return;

        window.gtag("config", GA_ID, {
            page_path: location.pathname + location.search,
        });
    }, [location]);
}
